import React from 'react';
import './ScrollButton.css';

class ScrollButton extends React.Component {
  state = {
    intervalId: 0,
    thePosition: false,
  };

  scrollStep = () => {
    if (window.pageYOffset === 0) {
      clearInterval(this.state.intervalId);
    }
    window.scroll(0, window.pageYOffset - this.props.scrollStepInPx);
  }

  scrollToTop() {
    let intervalId = setInterval(this.scrollStep(), '0');
    this.setState({ intervalId: intervalId });
  }

  handleScroll = () => {
    if (window.scrollY > 170) {
      this.setState({ thePosition: true });
    } else {
      this.setState({ thePosition: false });
    }
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
    window.scrollTo(0, 0);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  }

  render() {
    const { history } = this.props;
    return (
      <button
        title="Back to top"
        className="scroll"
        onClick={() => {
          this.scrollToTop();
          history.push('/');
        }}
      >
        <i className="fas fa-angle-up"></i>
      </button>
    );
  }
}

export default ScrollButton;
